import { IS_WEB } from '../../constants'

// React Native Web renders dataSet keys as kebab-case data-* attributes, so these must stay in step.
export const AURORA_INPUT_DATASET_KEY = 'auroraInput'
export const AURORA_INPUT_SELECTOR = '[data-aurora-input]'

/** Marks a web text input as Aurora-themed so the scoped ::selection rule applies to it. */
export const getAuroraInputProps = (isAuroraTheme: boolean) =>
  IS_WEB && isAuroraTheme ? { dataSet: { [AURORA_INPUT_DATASET_KEY]: '' } } : {}
